/**
 * GET-COLOR
 * Get hex value for list of colors
 */

const getColor = (color: string) => {
  switch (color) {
    case "red":
      return "#eb5a46"
    case "orange":
      return "#ff9500"
    case "yellow":
      return "#F2D600"
    case "green":
      return "#20CA7E"
    case "blue":
      return "#7d8ee0"
    default:
      return ""
  }
}

export default getColor
